import { addScript } from "../../bundles/helpers/add-script";
(async () => {
		if (!window.SimpleBar) await addScript(PUBLIC_PATH + 'vendor/simplebar.vendor.js');

		var detectionCssScrollBar = () => {
      document.body.insertAdjacentHTML('beforeend', `
      <div id="CustomScrollBar">
        <style>
        #CustomScrollBar { width: 99px; height: 99px; overflow: scroll; position: absolute; top: -999px }
        #CustomScrollBar::-webkit-scrollbar{ width: 40px }
        </style>
      </div>`);
      const elem = document.getElementById('CustomScrollBar');
      const result = (elem.offsetWidth - elem.clientWidth) === 40;
      elem.remove();
      return result;
    };
    var init = () => {
        Array.prototype.forEach.call(document.getElementsByClassName('custom-scroll-bar'), (item)=>{
            new SimpleBar(item);
        });
    };
    !detectionCssScrollBar() && init();
})();
